/* eslint-disable jsx-a11y/anchor-is-valid */

import {useState, useEffect} from 'react'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import {getUserByToken, profileImg, register} from '../core/_requests'
import {Link} from 'react-router-dom'
import {PasswordMeterComponent} from '../../../../_metronic/assets/ts/components'
import {storeLocalUser, useAuth} from '../core/Auth'
import ErrorAlert, {ErrorType} from '../../errors/ErrorAlert'
import {Box, LinearProgress} from '@mui/material'

const initialValues = {
  company_name: '',
  firstname: '',
  lastname: '',
  email: '',
  password: '',
  changepassword: '',
  profile_pic: null,
  acceptTerms: false,
}

const registrationSchema = Yup.object().shape({
  company_name: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(20, 'Maximum 20 symbols')
    .required('Company Name is required'),
  firstname: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(20, 'Maximum 20 symbols')
    .required('First name is required'),
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(30, 'Maximum 20 symbols')
    .required('Email is required'),
  lastname: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(20, 'Maximum 20 symbols')
    .required('Last name is required'),
  password: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(20, 'Maximum 20 symbols')
    .required('Password is required'),
  changepassword: Yup.string()
    .required('Password confirmation is required')
    .when('password', {
      is: (val: string) => (val && val.length > 0 ? true : false),
      then: Yup.string().oneOf([Yup.ref('password')], "Password and Confirm Password didn't match"),
    }),
  // profile_pic: Yup.mixed(),
  acceptTerms: Yup.bool().required('You must accept the terms and conditions'),
})

export function Registration() {
  const [loading, setLoading] = useState(false)
  const [uploadLoading, setUploadLoading] = useStat54
  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setErrorBody({error: false, error_list: []})
      setLoading(true)
      try {
        const {data: auth} = await register(
          values.company_name,
          values.email,
          values.firstname,
          values.lastname,
          values.password,
          values.changepassword,
          values.profile_pic
        )
        await saveAuth(auth)
        const {data: user} = await getUserByToken(auth.access)
        await storeLocalUser({...user, ...auth})
        await setCurrentUser(user)
      } catch (error) {
        console.error(error)
        saveAuth(undefined)
        let error_list = 'The registration details is incorrect <ul>'
        try {
          const err = (error as any)?.response?.data
          for (const [key, value] of Object.entries(err)) {
            error_list += '<li>' + (value as any)?.[0].replace('This field', key) + '</li>'
          }
        } catch (e) {}
        error_list += '</ul>'
        setStatus(error_list)
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  const uploadProfileImg = (event: any) => {
    const user_img = event.target.files
    try {
      let filesToUpload: any = []
      let lengthOfFiles = Object.keys(user_img).length
      if (user_img != null || lengthOfFiles > 0) {
        let img_kb = user_img[0].size / 1024
        if (img_kb > 1024 * 2) {
          setErrorBody({
            error: true,
            error_list: [
              `
             Oops! Image size should be less than ${(1024 * 2) / 1024}MB and your image size ${(
                user_img[0]?.size /
                1024 /
                1024
              ).toFixed(2)}MB
            `,
            ],
          })
          return
        }
        Object.values(user_img).map((value: any) => {
          return filesToUpload.push(value)
        })
      } else {
        console.error('file is not selected')
      }
      setUploadLoading(true)
      profileImg(filesToUpload, 'Profile_Pictures')
        .then((res) => {
          formik.setFieldValue('profile_pic', res?.data?.user_pic)
          setUploadLoading(false)
        })
        .catch((e) => {
          console.error(e)
          setUploadLoading(false)
        })
    } catch (e) {
      console.error(e)
    }
  }
  useEffect(() => {
    PasswordMeterComponent.bootstrap()
  }, [])

  return (
    <form
      className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      noValidate
      id='kt_login_signup_form'
      onSubmit={formik.handleSubmit}
    >



      {/* begin::Heading */}
      <div className='mb-10 text-center'>
        {/* begin::Title */}
        <h1 className='text-dark mb-3'>Sign Up</h1>
        {/* end::Title */}
      </div>
      {errorBody && <ErrorAlert error_response={errorBody} />}
      {formik.status && (
        <div className='mb-lg-15 alert alert-danger'>
          <div
            className='alert-text font-weight-bold'
            dangerouslySetInnerHTML={{__html: formik.status}}
          ></div>
        </div>
      )}

      {/* begin::Form group Company Name */}
      <div className='row fv-row mb-7'>
        <div className='col-xl-12 mb-6'>
          {/* <label className='class="form-label fw-bolder text -dark fs-6'>First name</label>  */}
          <input
            placeholder='Company Name'
            type='text'
            autoComplete='off'
            {...formik.getFieldProps('company_name')}
            className={clsx(
              'form-control form-control-lg form-control-solid',
              {
                'is-invalid': formik.touched.company_name && formik.errors.company_name,
              },
              {
                'is-valid': formik.touched.company_name && !formik.errors.company_name,
              }
            )}
          />
          {formik.touched.company_name && formik.errors.company_name && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.company_name}</span>
              </div>
            </div>
          )}
        </div>
        <div className='col-xl-12 mb-6'>
          {/* <label className='class="form-label fw-bolder text -dark fs-6'>First name</label>  */}
          <input
            placeholder='First name'
            type='text'
            autoComplete='off'
            {...formik.getFieldProps('firstname')}
            className={clsx(
              'form-control form-control-lg form-control-solid',
              {
                'is-invalid': formik.touched.firstname && formik.errors.firstname,
              },
              {
                'is-valid': formik.touched.firstname && !formik.errors.firstname,
              }
            )}
          />
          {formik.touched.firstname && formik.errors.firstname && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.firstname}</span>
              </div>
            </div>
          )}
        </div>
        <div className='col-xl-12'>
          {/* begin::Form group Lastname  */}
          <div className='fv-row mb-0'>
            {/* <label className='form-label fw-bolder text-dark fs-6'>Last name</label> */}
            <input
              placeholder='Last name'
              type='text'
              autoComplete='off'
              {...formik.getFieldProps('lastname')}
              className={clsx(
                'form-control form-control-lg form-control-solid',
                {
                  'is-invalid': formik.touched.lastname && formik.errors.lastname,
                },
                {
                  'is-valid': formik.touched.lastname && !formik.errors.lastname,
                }
              )}
            />
            {formik.touched.lastname && formik.errors.lastname && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.lastname}</span>
                </div>
              </div>
            )}
          </div>
          {/* end::Form group */}
        </div>
      </div>
      {/* end::Form group */}

      {/* begin::Form group Email */}
      <div className='fv-row mb-7'>
        {/* <label className='form-label fw-bolder text-dark fs-6'>Email</label> */}
        <input
          placeholder='Email'
          type='email'
          autoComplete='off'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {'is-invalid': formik.touched.email && formik.errors.email},
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.email}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group Password */}
      <div className='mb-10 fv-row' data-kt-password-meter='true'>
        <div className='mb-1'>
          {/* <label className='form-label fw-bolder text-dark fs-6'>Password</label> */}
          <div className='position-relative mb-3'>
            <input
              type='password'
              placeholder='Password'
              autoComplete='off'
              {...formik.getFieldProps('password')}
              className={clsx(
                'form-control form-control-lg form-control-solid',
                {
                  'is-invalid': formik.touched.password && formik.errors.password,
                },
                {
                  'is-valid': formik.touched.password && !formik.errors.password,
                }
              )}
            />
            {formik.touched.password && formik.errors.password && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.password}</span>
                </div>
              </div>
            )}
          </div>
          {/* begin::Meter */}
          <div
            className='d-flex align-items-center mb-3'
            data-kt-password-meter-control='highlight'
          >
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px'></div>
          </div>
          {/* end::Meter */}
        </div>
        <div className='text-muted'>
          Use 8 or more characters with a mix of letters, numbers & symbols.
        </div>
      </div>
      {/* end::Form group */}

      {/* begin::Form group Confirm password */}
      <div className='fv-row mb-5'>
        {/* <label className='form-label fw-bolder text-dark fs-6'>Confirm Password</label> */}
        <input
          type='password'
          placeholder='Repeat Password'
          autoComplete='off'
          {...formik.getFieldProps('changepassword')}
          className={clsx(
            'form-control form-control-lg form-control-solid',
            {
              'is-invalid': formik.touched.changepassword && formik.errors.changepassword,
            },
            {
              'is-valid': formik.touched.changepassword && !formik.errors.changepassword,
            }
          )}
        />
        {formik.touched.changepassword && formik.errors.changepassword && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.changepassword}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group Email */}
      <div className='fv-row mb-7'>
        <input
          type='file'
          autoComplete='off'
          accept='image/*'
          onChange={uploadProfileImg}
          className={clsx('form-control form-control-lg form-control-solid')}
        />
        {formik.touched.profile_pic && formik.errors.profile_pic && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.profile_pic}</span>
            </div>
          </div>
        )}
        {uploadLoading && (
          <Box sx={{width: '100%'}}>
            <LinearProgress color='primary' />
          </Box>
        )}
      </div>

      {/* begin::Form group */}
      <div className='fv-row mb-10'>
        <div className='form-check form-check-custom form-check-solid'>
          <input
            className='form-check-input'
            type='checkbox'
            id='kt_login_toc_agree'
            {...formik.getFieldProps('acceptTerms')}
          />
          <label
            className='form-check-label fw-bold text-gray-700 fs-6'
            htmlFor='kt_login_toc_agree'
          >
            I Agree the{' '}
            <Link to='/auth/terms' className='ms-1 link-primary'>
              terms and conditions
            </Link>
            .
          </label>
          {formik.touched.acceptTerms && formik.errors.acceptTerms && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.acceptTerms}</span>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='text-center'>
        <button
          type='submit'
          id='kt_sign_up_submit'
          className='btn btn-lg btn-primary w-100 mb-5'
          disabled={formik.isSubmitting || !formik.isValid || !formik.values.acceptTerms}
        >
          {!loading && <span className='indicator-label'>Sign Up</span>}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Please wait...{' '}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
        <div className='text-gray-400 fw-bold fs-4'>
          Already have an account?{' '}
          <Link to='/auth' className='link-primary fw-bolder'>
            Sign in
          </Link>
        </div>
        {/* <Link to='/auth/login'>
          <button
            type='button'
            id='kt_login_signup_form_cancel_button'
            className='btn btn-lg btn-light-primary w-100 mb-5'
          >
            Cancel
          </button>
        </Link> */}
      </div>
      {/* end::Form group */}
    </form>
  )
}
